export const isMobile = () =>
  /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export const isAndroid = () => /Android/i.test(navigator.userAgent);
